/** Why a cell-values write failed; the caller turns it into the text of its own toast. */
export enum DatabaseItemCellValuesWriteFailureReasonType {
  /** The write job failed after its retries (validation on the worker, item locked by a bulk update). */
  JobFailed = 'job-failed',
  /** The request was refused with a 4xx (INVALID_REQUEST, an invalid field value). */
  Rejected = 'rejected',
  /** The record no longer exists. */
  NotFound = 'not-found',
  /** 403 NoPermissions. */
  NoPermissions = 'no-permissions',
  /** 5xx, a network failure, a billing block, a policy limit, a session that could not be renewed, rate limiting. */
  Unavailable = 'unavailable',
  /** The API was unreachable, so the request was dropped instead of being sent after the reconnect. */
  Offline = 'offline',
}
